import React from 'react'

import { Group } from '@/core/api/entities/group'
import { Zone } from '@/core/api/entities/zone/zone'
import { useTranslation } from '@/core/i18n/useTranslation'
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal/ConfirmationModal'

interface RemoveZoneFromGroupModalProps {
	visible: boolean
	zone: Zone | null
	group: Group | null
	onClose: () => void
	onConfirm: () => void
	isRemoving: boolean
}

const RemoveZoneFromGroupModal: React.FC<RemoveZoneFromGroupModalProps> = ({
	visible,
	zone,
	group,
	onClose,
	onConfirm,
	isRemoving,
}) => {
	const { t } = useTranslation('common')

	return (
		<ConfirmationModal
			visible={visible}
			title={t('entities.group.remove_zone.title')}
			description={t('entities.group.remove_zone.description', {
				zoneName: zone?.name,
				groupName: group?.name,
			})}
			confirmText={t('entities.group.remove_zone.confirm')}
			cancelText={t('actions.cancel')}
			variant="destructive"
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isRemoving}
			loadingText={t('actions.loading')}
		/>
	)
}

export default RemoveZoneFromGroupModal
